<div class="resources-wrapper w-full">
  <div class="close-wrapper flex justify-end">
    <app-icon (click)="closeButtonClickHandler()"
              class="cursor-pointer close-icon"
              svgIcon="cross"></app-icon>
  </div>
  <div class="resources-heading flex justify-center font-semibold font-poppins">
    Find Resources
  </div>
  <div
    class="w-full flex justify-center flex-col items-center">
    <div class="w-[90%] resource-search-input-section">
      <app-text-input
        [parentFormGroup]="relatedResources"
        [suffixIcon]="'search'"
        controlName="resourceSearchedText"
        label="Search Resources"
        placeholder="Search Resources"
        type="small"
      ></app-text-input>
    </div>
    <div (scrolled)="getNext()"
         *ngIf="!loading || paginationRelatedLoading"
         [alwaysCallback]="true"
         [infiniteScrollDistance]="scrollDistance"
         [infiniteScrollThrottle]="throttle"
         [infiniteScrollUpDistance]="scrollUpDistance"
         [scrollWindow]="false"
         class="w-[90%] table-wrapper"
         infinite-scroll>
      <table
        [dataSource]="dataSource"
        mat-table
      >
        <ng-container
          matColumnDef="title"
        >
          <th
            *matHeaderCellDef
            class="w-[25%]"
            mat-header-cell
          >
            <div class="th-cell">
              Resource
            </div>
          </th>
          <td *matCellDef="let eachRow;let index=index"
              mat-cell>
            <div class="td-cell">
              <div>
                <mat-checkbox
                  (change)="onAddRelatedResource($event,index,eachRow)"
                  [checked]="eachRow.checked"
                  aria-label="Select an option"
                  class="checkbox small"
                >
                </mat-checkbox>
              </div>
              <div class="clickable" (click)="openRelatedResource(eachRow)">
                {{eachRow.title}}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container
          matColumnDef="category"
        >
          <th
            *matHeaderCellDef
            class="w-[30%]"
            mat-header-cell
          >
            <div class="th-cell resource-categories-title">
              Categories
            </div>
          </th>
          <td *matCellDef="let eachRow"
              mat-cell>
            <div class="td-cell resource-categories-title">
              {{getCategoriesName(eachRow.categories)}}
            </div>
          </td>
        </ng-container>
        <ng-container
          matColumnDef="subCategories"
        >
          <th
            *matHeaderCellDef
            class="w-[45%]"
            mat-header-cell
          >
            <div class="th-cell resource-categories-title">
              Sub Categories
            </div>
          </th>
          <td *matCellDef="let eachRow"
              mat-cell>
            <div class="td-cell resource-categories-title">
              {{getSubCategoriesName(eachRow.categories)}}
            </div>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns; sticky: true"
            mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;"
            mat-row></tr>

      </table>
      <div
        class="flex justify-center items-center pagination-loading-wrapper">
        <mat-spinner
          *ngIf="loading && paginationRelatedLoading"
          [diameter]="40"
          mode="indeterminate"
          strokeWidth="5"
        />
      </div>
    </div>
    <div *ngIf="!loading || paginationRelatedLoading"
         class="w-[95%] flex justify-end confirm-button-wrapper">
      <app-primary-button (click)="conformButtonClicked()"
                          [type]="'small'">
        Confirm
      </app-primary-button>
    </div>
  </div>
  <div *ngIf="loading && !paginationRelatedLoading"
       class="flex justify-center items-center loading-wrapper">
    <mat-spinner
      [diameter]="100"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
</div>
